import { Box, CardContent, CardHeader, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import React from 'react';

interface InstagramPostMetrics {
    timestamp: string;
    caption: string;
    id: string;
    engagementRate: string;
    media_url: string;
    likes: string;
    comments: string;
    follows: string;
    profile_activity: string;
    reach: string;
    total_interactions: string;
    impressions: string;
    reactions: number;
}

interface PostCardProps {
    post: InstagramPostMetrics;
}

interface InstagramPostInsightsProps {
    InstagramPostInsightsMetrics?: InstagramPostMetrics[] | null;
}

const InstagramPostInsights: React.FC<InstagramPostInsightsProps> = ({ InstagramPostInsightsMetrics }) => {


    return (
        <Card sx={{ maxWidth: '90%', margin: '0 auto', mt: 10, mb: 2 }}>
            <CardHeader title={"Posts"}>
            </CardHeader>
            <CardContent>
                {InstagramPostInsightsMetrics?.map(post => <PostCard post={post} key={post.id} />)}
            </CardContent>
        </Card>
    )
}


const PostCard: React.FC<PostCardProps> = ({ post }) => {

    const formatTime = (time: string) => {
        const date = new Date(time);
        const options: Intl.DateTimeFormatOptions = {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        return date.toLocaleString('en-US', options);
    }

    return (
        <Box sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: '5px', display: 'flex' }}>
            <Box sx={{ mr: 2, width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', borderRadius: '5px' }}>
                {post.media_url ?
                    <img src={post.media_url} alt="post" style={{ borderRadius: '5px', maxWidth: '100%', maxHeight: '100%' }} /> :
                    <Typography variant="body2" color="textSecondary">No Picture</Typography>
                }
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography variant="body1" sx={{ mb: 1 }}>{post.caption}</Typography>
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid item xs={4}><Typography variant="body2">Impressions: {post.impressions}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Reach: {post.reach}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Likes: {post.likes}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Comments: {post.comments}</Typography></Grid>
                    <Grid item xs={4}><Typography variant="body2">Engagement Rate: {post.engagementRate} %</Typography></Grid>
                </Grid>
                <Typography variant="body2" color="textSecondary">{formatTime(post.timestamp)}</Typography>
            </Box>
        </Box>
    );
}
export default InstagramPostInsights;